import React, { useEffect } from 'react';
import { Cart } from 'rsl-api-106/lib/types';

declare global {
  interface Window {
    trackdata: any;
  }
}

type Props = {
  cartState: Cart | null;
};

const SelligentTrackingScript: React.FC<Props> = ({ cartState }) => {
  useEffect(() => {
    try {
      window.trackdata = window.trackdata || [];
      window.trackdata.push("aOcqflias");
      window.trackdata.push(cartState?.reservations?.[0]?.property?.id); // Default value for PRODUCTID
      window.trackdata.push(cartState?.reservations?.[0]?.stays?.length); // Default value for QTY
      window.trackdata.push(cartState?.reservations?.[0]?.totalAmount?.amount); // Default value for PRICE
      window.trackdata.push(
        cartState?.reservations?.[0]?.selectedPaymentMethod
      ); // Default value for PAYMENT_TYPE
      window.trackdata.push(roomInfosTitle()); // Default value for CATEGORY
      window.trackdata.push(cartState?.reservations?.[0]?.id); // Default value for TRANSACTIONID
      window.trackdata.push(
        cartState?.reservations?.[0]?.primaryOccupant?.customerCode
      ); // Default value for CUSTOMER_NUMBER
      window.trackdata.push(
        cartState?.reservations?.[0]?.totalAmount?.currencyCode
      ); // Default value for CURRENCY

      // Création et insertion du script
      if (!document.getElementById("webtracker")) {
        const script = document.createElement("script");
        script.id = "webtracker";
        script.src = "//octelio.emsecure.net/optiext/webtracker.dll";
        script.async = true;

        const firstScript = document.getElementsByTagName("script")[0];
        firstScript?.parentNode?.insertBefore(script, firstScript);
      }
    } catch (error) {
      console.error("Erreur lors de l’injection du script de tracking:", error);
    }

    // Nettoyage optionnel
    return () => {
      const existingScript = document.getElementById("webtracker");
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  const roomInfosTitle = () => {
    let title = "";
    cartState?.reservations![0]?.stays?.forEach((stay, stayIndex) => {
      return (
        <div>
          {" "}
          {stay?.distribution?.roomTypes?.forEach((roomInfo, roomInfoIndex) => {
            title =
              title +
              `${stayIndex === 0 ? "" : "+ "} ${roomInfo?.quantity}x ${
                roomInfo?.label ?? ""
              } `;
          })}
        </div>
      );
    });
    return title;
  };

  return null;
};

export default SelligentTrackingScript;
